import React from 'react';
import { capitalize } from '@material-ui/core';
import PropTypes from 'prop-types';
import styles from './AccessCodeOnlyForm.module.scss';

export default function NoSpringImagesWarning({ season }) {
  const displaySeason = () => {
    if (!season) return '';

    const seasonParts = season.split('20');

    if (seasonParts.length === 1) return capitalize(season);

    const part1 = capitalize(seasonParts[0]);
    const part2 = `20${seasonParts.slice(1, seasonParts.length + 1).join('')}`;

    return `${part1} ${part2}`;
  };

  return (
    <div className={styles.noSpringImagesWarning}>
      <span>
        Spring images are not available for your student yet and this is not an access code for the Spring 2023 season.
      </span>
      {season && (
        <span>
          {displaySeason()}
          {' '}
          images are still available to be purchased.
        </span>
      )}
    </div>
  );
}

NoSpringImagesWarning.defaultProps = {
  season: '',
};

NoSpringImagesWarning.propTypes = {
  season: PropTypes.string,
};
